import packageJson from '@packageJson';

export const APP_VERSION = packageJson.version;
export const TARGET_ORIGIN = '*';
export const SIDEBAR_WIDTH = 260;
export const MAX_FILE_UPLOAD_SIZE = 2_097_152; // 2 MiB
